var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkLifeShopBagIconHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0297 33.2497H4.96972C4.76991 33.2524 4.57169 33.2139 4.38743 33.1366C4.20318 33.0593 4.03687 32.9447 3.8989 32.8002C3.76092 32.6557 3.65426 32.4842 3.58557 32.2966C3.51689 32.1089 3.48766 31.9091 3.49972 31.7097L4.79472 8.08465C4.81271 7.71168 4.97365 7.35997 5.24412 7.10254C5.51459 6.8451 5.87382 6.70172 6.24722 6.70215H28.7347C29.1081 6.70172 29.4673 6.8451 29.7378 7.10254C30.0083 7.35997 30.1692 7.71168 30.1872 8.08465L31.4997 31.7097C31.5118 31.9091 31.4825 32.1089 31.4139 32.2966C31.3452 32.4842 31.2385 32.6557 31.1005 32.8002C30.9626 32.9447 30.7963 33.0593 30.612 33.1366C30.4277 33.2139 30.2295 33.2524 30.0297 33.2497Z",
    fill: "#8733A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M11.1826 11.935V15.435H23.8176V7.7175C23.8176 6.13482 23.1889 4.61696 22.0698 3.49784C20.9507 2.37872 19.4328 1.75 17.8501 1.75H17.1501C15.5674 1.75 14.0496 2.37872 12.9305 3.49784C11.8113 4.61696 11.1826 6.13482 11.1826 7.7175V8.0675V11.935Z",
    fill: "#2CF0C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkLifeShopBagIconHover);
export default __webpack_public_path__ + "static/media/WorkLifeShopBagIconHover.abb07a8728b44c8664af236098fada2a.svg";
export { ForwardRef as ReactComponent };